<div class="page-container gap-24">
  <app-title-card id="title-card" [titleCard]="titleCard"></app-title-card>
  <span class="align-self-stretch subtitle">
    Gemeinsam für eine zukunftsfähige Bildung – Fortbildungen von InWi für Ihre
    Lernenden
  </span>
  <div class="flex-c gap-8">
    <span class="align-self-stretch font-regular-body-large">
      Ihr Ziel ist es, Lernende mit evidenzbasiertem Wissen optimal auf ihre
      berufliche Zukunft vorzubereiten? InWi bietet maßgeschneiderte
      Fortbildungen für Schulen und Hochschulen – inklusive besonderer
      Konditionen und flexibler Terminplanung.
    </span>
    <span class="align-self-stretch font-regular-body-large">
      Unsere Gruppenfortbildungen vereinen fundiertes Fachwissen mit praxisnaher
      Anwendung und ergänzendem Lernmaterial, das die nachhaltige Umsetzung im
      Unterricht unterstützt.
    </span>
  </div>
  <span class="align-self-stretch subtitle">
    Unser Angebot für Schulen und Hochschulen:
  </span>
  <ul class="align-self-stretch">
    <li>
      <span class="font-bold-body-large"> Evidenzbasierte Inhalte: </span>
      <span class="font-regular-body-large">
        Wir vermitteln Wissen, das auf aktuellen wissenschaftlichen
        Erkenntnissen basiert. So stellen wir sicher, dass Ihre Lernenden
        bestens informiert und zukunftsorientiert ausgebildet sind.
      </span>
    </li>
    <li>
      <span class="font-bold-body-large"> Praxisnähe: </span>
      <span class="font-regular-body-large">
        Unsere Fortbildungen verbinden Theorie mit praktischen Beispielen und
        Methoden, die direkt im Schul- oder Hochschulalltag angewendet werden
        können.
      </span>
    </li>
    <li>
      <span class="font-bold-body-large"> Gruppenfortbildungen: </span>
      <span class="font-regular-body-large">
        Ideal für Klassen, Jahrgangsstufen oder Studierendengruppen. Gemeinsam
        erarbeitetes Wissen wird vertieft und gefestigt – für einen maximalen
        Lerneffekt.
      </span>
    </li>
    <li>
      <span class="font-bold-body-large"> Ergänzendes Zugangsmaterial: </span>
      <span class="font-regular-body-large">
        Ergänzend zur Fortbildung erhalten Ihre Lernenden Zugriff auf
        umfangreiche digitale Materialien. Diese unterstützen die Nachbereitung
        und können jederzeit im Unterricht genutzt werden.
      </span>
    </li>
  </ul>
  <span class="align-self-stretch subtitle"> Unsere Partner-Schulen </span>
  <div class="flex-r gap-16">
    <img
      src="../../../../../assets/images/partners/Bildungsgruppe-Lang-VIDACTA-Logo-Blau.png"
      alt=""
      height="150" />
  </div>
  <span class="align-self-stretch subtitle"> Warum InWi? </span>
  <ul class="align-self-stretch">
    <li>
      <span class="font-bold-body-large"> Expertise: </span>
      <span class="font-regular-body-large">
        Unsere Dozierenden sind erfahrene Fachleute, die Inhalte professionell
        und verständlich vermitteln.
      </span>
    </li>
    <li>
      <span class="font-bold-body-large"> Flexibilität: </span>
      <span class="font-regular-body-large">
        Wir passen unsere Fortbildungen an die spezifischen Anforderungen Ihrer
        Schule, Hochschule oder Ihrer Lernenden an – soweit dies im Rahmen
        evidenzbasierter Ansätze möglich ist.
      </span>
    </li>
  </ul>
  <span class="flex-c gap-8 align-self-stretch">
    <span class="font-bold-body-large"> Interesse geweckt? </span>
    <span class="font-regular-body-large">
      Gemeinsam gestalten wir Fortbildungen, die Lernende inspirieren und ihre
      Fähigkeiten gezielt weiterentwickeln. Kontaktieren Sie uns für weitere
      Informationen oder ein individuelles Angebot – wir freuen uns auf eine
      erfolgreiche Zusammenarbeit!
    </span>
  </span>
</div>
<div class="sticky-container-bottom">
  <button class="inwi-text-button-large-primary" routerLink="/about/contact">
    <div class="button-content">
      <div class="button-text">Melde dich jetzt</div>
    </div>
  </button>
</div>
